var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStore3A5B8Df3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M124.249,0H10.757c-.414,0-.822,0-1.235,0C9.176,0,8.834.01,8.485.015A16.772,16.772,0,0,0,6.224.191,8.208,8.208,0,0,0,4.08.818,7.294,7.294,0,0,0,2.254,2,6.352,6.352,0,0,0,.924,3.618a6.093,6.093,0,0,0-.705,1.9,11.559,11.559,0,0,0-.2,2c-.01.307-.012.614-.017.921V31.559c.006.31.007.611.017.922a11.559,11.559,0,0,0,.2,2,6.08,6.08,0,0,0,.705,1.9A6.305,6.305,0,0,0,2.254,38,7.109,7.109,0,0,0,4.08,39.18a8.249,8.249,0,0,0,2.144.631,17.077,17.077,0,0,0,2.261.177c.349.007.691.011,1.037.011.413,0,.821,0,1.235,0H124.249c.405,0,.817,0,1.223,0,.344,0,.7,0,1.04-.011a16.853,16.853,0,0,0,2.256-.177,8.379,8.379,0,0,0,2.153-.631A7.111,7.111,0,0,0,132.746,38a6.5,6.5,0,0,0,1.333-1.614,6.091,6.091,0,0,0,.7-1.9,12.019,12.019,0,0,0,.209-2c0-.311,0-.611,0-.922.009-.363.009-.725.009-1.094V9.536c0-.366,0-.729-.009-1.092,0-.307,0-.614,0-.921a12.018,12.018,0,0,0-.209-2,6.1,6.1,0,0,0-.7-1.9,6.938,6.938,0,0,0-3.157-2.8,8.336,8.336,0,0,0-2.153-.627,16.554,16.554,0,0,0-2.256-.177c-.344,0-.7-.011-1.04-.013-.405,0-.817,0-1.223,0Z",
    transform: "translate(0 0)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M9.43,39.125c-.344,0-.68,0-1.022-.011A16.158,16.158,0,0,1,6.3,38.951,7.266,7.266,0,0,1,4.423,38.4a6.136,6.136,0,0,1-1.579-1.017,5.407,5.407,0,0,1-1.153-1.4,5.275,5.275,0,0,1-.614-1.657A11.025,11.025,0,0,1,.89,32.458c-.007-.211-.017-.913-.017-.913V8.444s.01-.691.017-.895a10.986,10.986,0,0,1,.187-1.872,5.305,5.305,0,0,1,.614-1.662,5.455,5.455,0,0,1,1.147-1.4A6.316,6.316,0,0,1,4.423,1.6a7.194,7.194,0,0,1,1.868-.544A16.028,16.028,0,0,1,8.41.887L9.43.875H125.564L126.6.888a15.772,15.772,0,0,1,2.1.163,7.337,7.337,0,0,1,1.888.548,6.007,6.007,0,0,1,2.729,2.42,5.309,5.309,0,0,1,.6,1.649,11.545,11.545,0,0,1,.2,1.887c0,.283,0,.587,0,.89.009.375.009.732.009,1.092V30.465c0,.363,0,.718-.009,1.075,0,.325,0,.623,0,.93a11.309,11.309,0,0,1-.193,1.854,5.286,5.286,0,0,1-.61,1.67,5.572,5.572,0,0,1-1.148,1.386,6.141,6.141,0,0,1-1.581,1.022,7.241,7.241,0,0,1-1.885.55,15.973,15.973,0,0,1-2.112.163c-.331.007-.678.011-1.014.011l-1.225,0Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(9.972 8.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M24.769,20.3a4.949,4.949,0,0,1,2.357-4.152,5.066,5.066,0,0,0-3.991-2.158c-1.679-.176-3.307,1-4.163,1-.872,0-2.19-.987-3.608-.958a5.315,5.315,0,0,0-4.473,2.728c-1.934,3.348-.491,8.269,1.361,10.976.927,1.325,2.01,2.806,3.428,2.753,1.387-.058,1.905-.884,3.579-.884,1.659,0,2.145.884,3.591.851,1.488-.024,2.426-1.331,3.321-2.669A10.962,10.962,0,0,0,27.688,24.7,4.782,4.782,0,0,1,24.769,20.3Z",
    transform: "translate(-9.972 -8.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M22.037,12.211A4.872,4.872,0,0,0,23.152,8.72a4.957,4.957,0,0,0-3.208,1.66A4.636,4.636,0,0,0,18.8,13.741,4.1,4.1,0,0,0,22.037,12.211Z",
    transform: "translate(-9.972 -8.72)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(24.456 9.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M42.3,27.14H37.569L36.432,30.5h-2l4.483-12.418h2.083L45.477,30.5H43.438Zm-4.243-1.549h3.752l-1.85-5.447H39.91Z",
    transform: "translate(-34.427 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M55.16,25.97c0,2.813-1.506,4.621-3.778,4.621a3.069,3.069,0,0,1-2.849-1.584H48.49v4.484H46.631V21.442h1.8v1.506h.034a3.212,3.212,0,0,1,2.883-1.6C53.645,21.348,55.16,23.164,55.16,25.97Zm-1.91,0c0-1.833-.947-3.038-2.393-3.038-1.42,0-2.375,1.23-2.375,3.038,0,1.824.955,3.046,2.375,3.046C52.3,29.016,53.25,27.819,53.25,25.97Z",
    transform: "translate(-34.427 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M65.125,25.97c0,2.813-1.506,4.621-3.778,4.621A3.069,3.069,0,0,1,58.5,29.007h-.043v4.484H56.6V21.442h1.8v1.506h.034a3.212,3.212,0,0,1,2.883-1.6C63.61,21.348,65.125,23.164,65.125,25.97Zm-1.91,0c0-1.833-.947-3.038-2.393-3.038-1.42,0-2.375,1.23-2.375,3.038,0,1.824.955,3.046,2.375,3.046,1.445,0,2.393-1.2,2.393-3.046Z",
    transform: "translate(-34.427 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M71.71,27.036c.138,1.231,1.334,2.04,2.969,2.04,1.566,0,2.693-.809,2.693-1.919,0-.964-.68-1.541-2.289-1.937l-1.609-.388c-2.28-.551-3.339-1.617-3.339-3.348,0-2.143,1.867-3.614,4.519-3.614,2.624,0,4.423,1.472,4.483,3.614H77.261c-.112-1.239-1.137-1.987-2.634-1.987s-2.521.757-2.521,1.858c0,.878.654,1.395,2.255,1.79l1.368.336c2.548.6,3.606,1.626,3.606,3.442,0,2.323-1.851,3.778-4.794,3.778-2.754,0-4.613-1.421-4.733-3.667Z",
    transform: "translate(-34.427 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M83.346,19.3v2.143h1.722v1.472H83.346v4.991c0,.775.345,1.137,1.1,1.137A5.807,5.807,0,0,0,85.059,29v1.463a5.1,5.1,0,0,1-1.032.086c-1.833,0-2.548-.688-2.548-2.444V22.914H80.163V21.442h1.316V19.3Z",
    transform: "translate(-34.427 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M86.065,25.97c0-2.849,1.678-4.639,4.294-4.639s4.295,1.79,4.295,4.639-1.661,4.639-4.295,4.639S86.065,28.826,86.065,25.97Zm6.7,0c0-1.954-.9-3.107-2.4-3.107s-2.4,1.162-2.4,3.107c0,1.962.895,3.106,2.4,3.106s2.4-1.145,2.4-3.106Z",
    transform: "translate(-34.427 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M96.186,21.442h1.772v1.541H98a2.159,2.159,0,0,1,2.178-1.636,2.866,2.866,0,0,1,.637.069v1.738a2.6,2.6,0,0,0-.835-.112,1.873,1.873,0,0,0-1.937,2.083V30.5H96.186Z",
    transform: "translate(-34.427 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M109.384,27.837c-.25,1.644-1.851,2.771-3.9,2.771-2.634,0-4.269-1.765-4.269-4.6s1.644-4.682,4.19-4.682c2.5,0,4.08,1.721,4.08,4.466v.637h-6.395v.112a2.358,2.358,0,0,0,2.436,2.564,2.048,2.048,0,0,0,2.091-1.273Zm-6.282-2.7h4.526a2.177,2.177,0,0,0-2.221-2.3,2.292,2.292,0,0,0-2.306,2.3Z",
    transform: "translate(-34.427 -17.871)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>",
    transform: "translate(36.627 8.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M37.826,8.731A2.64,2.64,0,0,1,40.634,11.7c0,1.906-1.03,3-2.808,3H35.671V8.731ZM36.6,13.854h1.125a1.876,1.876,0,0,0,1.968-2.146,1.881,1.881,0,0,0-1.968-2.134H36.6Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M41.681,12.444a2.133,2.133,0,1,1,4.247,0,2.134,2.134,0,1,1-4.247,0Zm3.333,0c0-.976-.438-1.547-1.208-1.547s-1.207.571-1.207,1.547.435,1.55,1.207,1.55,1.208-.57,1.208-1.55Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M51.573,14.7h-.922l-.931-3.316h-.07L48.724,14.7h-.913l-1.241-4.5h.9l.807,3.436h.066l.926-3.436h.853l.926,3.436h.07l.8-3.436h.889Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M53.854,10.195h.855v.715h.066a1.348,1.348,0,0,1,1.344-.8,1.465,1.465,0,0,1,1.559,1.675V14.7h-.889V12.006c0-.724-.314-1.083-.972-1.083a1.033,1.033,0,0,0-1.075,1.141V14.7h-.889Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M59.094,8.437h.889V14.7h-.889Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M61.218,12.444a2.133,2.133,0,1,1,4.248,0,2.134,2.134,0,1,1-4.248,0Zm3.333,0c0-.976-.438-1.547-1.208-1.547s-1.207.571-1.207,1.547.435,1.55,1.207,1.55,1.208-.57,1.208-1.55Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M66.4,13.424c0-.811.6-1.278,1.675-1.344l1.22-.07v-.389c0-.476-.314-.744-.922-.744-.5,0-.84.182-.938.5h-.86c.091-.773.818-1.27,1.84-1.27,1.129,0,1.766.562,1.766,1.513V14.7h-.855v-.633h-.07a1.515,1.515,0,0,1-1.353.707,1.36,1.36,0,0,1-1.5-1.348ZM69.3,13.04v-.376l-1.1.07c-.62.042-.9.252-.9.649s.352.641.835.641A1.061,1.061,0,0,0,69.3,13.04Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M71.348,12.444c0-1.423.731-2.324,1.869-2.324a1.484,1.484,0,0,1,1.381.79h.066V8.437h.889V14.7H74.7v-.711h-.07a1.563,1.563,0,0,1-1.414.786C72.072,14.772,71.348,13.871,71.348,12.444Zm.918,0c0,.955.45,1.53,1.2,1.53s1.212-.583,1.212-1.526-.468-1.53-1.212-1.53-1.2.579-1.2,1.526Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M79.23,12.444a2.133,2.133,0,1,1,4.247,0,2.134,2.134,0,1,1-4.247,0Zm3.333,0c0-.976-.438-1.547-1.208-1.547s-1.207.571-1.207,1.547.435,1.55,1.207,1.55S82.563,13.424,82.563,12.444Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M84.669,10.195h.855v.715h.066a1.348,1.348,0,0,1,1.344-.8,1.465,1.465,0,0,1,1.559,1.675V14.7h-.889V12.006c0-.724-.314-1.083-.972-1.083a1.033,1.033,0,0,0-1.075,1.141V14.7h-.889Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M93.515,9.074v1.142h.976v.749h-.976v2.315c0,.472.194.678.637.678a2.966,2.966,0,0,0,.339-.021v.74a2.915,2.915,0,0,1-.483.045c-.988,0-1.382-.348-1.382-1.216V10.964h-.715v-.749h.715V9.074Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M95.7,8.437h.881v2.481h.07a1.386,1.386,0,0,1,1.373-.807,1.483,1.483,0,0,1,1.551,1.679V14.7h-.89V12.01c0-.719-.335-1.083-.963-1.083a1.052,1.052,0,0,0-1.134,1.142V14.7H95.7Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M104.761,13.482a1.828,1.828,0,0,1-1.951,1.3,2.045,2.045,0,0,1-2.08-2.324,2.077,2.077,0,0,1,2.076-2.353c1.253,0,2.009.856,2.009,2.27v.31h-3.18v.05a1.19,1.19,0,0,0,1.2,1.29,1.079,1.079,0,0,0,1.071-.546Zm-3.126-1.451h2.274a1.086,1.086,0,0,0-1.108-1.167,1.152,1.152,0,0,0-1.166,1.167Z",
    transform: "translate(-35.671 -8.437)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore3A5B8Df3);
export default __webpack_public_path__ + "static/media/AppStore.3a5b8df3.3835ecd345f5fee92157621b28a6f471.svg";
export { ForwardRef as ReactComponent };